import React from 'react';
import { profile } from '../data/profile';

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container footer-row">
        <div>
          <strong>{profile.name}</strong>
          <p>
            {profile.role} · {profile.location}
          </p>
          <p>© {year}</p>
        </div>
        <nav>
          <a href="#experience">Experience</a>
          <a href="#work">Work</a>
          <a href="#recognition">Recognition</a>
          <a href={profile.links.github} target="_blank" rel="noopener noreferrer">
            GitHub
          </a>
          <a href={profile.links.linkedin} target="_blank" rel="noopener noreferrer">
            LinkedIn
          </a>
        </nav>
      </div>
    </footer>
  );
};

export default Footer;
